import React, {useContext, useMemo} from 'react';
import {Box, IconButton, InputAdornment, TextField, Typography} from '@mui/material';
import IconSendOutline from '@assets/components/ResouceIcon/IconSendOutline';
import {FloatButtonContext} from '@assets/contexts/floatButtonContext';
import {DEFAULT_MESSAGE_TYPE} from '@functions/helpers/defaultCampaignSetting';
import ProductRecommendationPopup from './ProductRecommendationPopup';
import PropTypes from 'prop-types';
import {useWidgetLabelChanged} from '@assets/pages/Widget/WidgetLabelChangedProvider';
import {cleanString} from '@assets/helpers/blockXSSAttack';

export default function CartBoosterPopup({
  campaign,
  i18nCampaign,
  handleClick,
  sx,
  setFetchedRecommendedProduct
}) {
  const {isLabelChanged} = useWidgetLabelChanged();
  const message = useMemo(() => {
    switch (campaign?.message?.type) {
      case DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION:
        return isLabelChanged
          ? cleanString(campaign?.message?.productContent)
          : i18nCampaign('productMessage', campaign?.id) || campaign?.message?.productContent;
      case DEFAULT_MESSAGE_TYPE.DISCOUNT:
        return isLabelChanged
          ? cleanString(campaign?.message?.discountContent)
          : i18nCampaign('discountMessage', campaign?.id) || campaign?.message?.discountContent;
      default:
        return isLabelChanged
          ? cleanString(campaign?.message?.content)
          : i18nCampaign('message', campaign?.id) || campaign?.message?.content;
    }
  }, [isLabelChanged, campaign?.message?.type, campaign?.id, i18nCampaign]);

  const {i18n} = useContext(FloatButtonContext);
  if (campaign?.message?.type === DEFAULT_MESSAGE_TYPE.PRODUCT_RECOMMENDATION) {
    return (
      <ProductRecommendationPopup
        campaign={campaign}
        i18nCampaign={i18nCampaign}
        setFetchedRecommendedProduct={setFetchedRecommendedProduct}
        sx={sx}
        handleClick={handleClick}
      />
    );
  }
  return (
    <div className="Avada-SubscribeNewsletter__Content" onClick={() => handleClick(campaign)}>
      <div
        className="AvadaFaqs-MUI-WPMessageTextFont"
        style={{textAlign: 'left', marginRight: '20px'}}
      >
        <Typography
          variant="div"
          style={{fontSize: '14px', color: '#000000', position: 'relative'}}
        >
          <span
            className="Avada-PopupV2__Message"
            dangerouslySetInnerHTML={{
              __html: message?.replaceAll('\n', '<br/>').replaceAll('\\n', '<br/>')
            }}
          />
        </Typography>
      </div>

      <Box>
        <TextField
          fullWidth
          placeholder={i18n('Click to reply')}
          variant="filled"
          sx={{'& .MuiFilledInput-root': sx.inputRoot, '& .MuiFilledInput-input': sx.input}}
          slotProps={{
            input: {
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton sx={sx.iconButton}>
                    <IconSendOutline fill="#cccccc" />
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />
      </Box>
    </div>
  );
}

CartBoosterPopup.propTypes = {
  campaign: PropTypes.object.isRequired,
  i18nCampaign: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired
};
